/*export const urlBase = window.location.origin
export const urlHost = '/ortoromi_24/wp/'
export const themeDir = '/ortoromi_24/wp/wp-content/themes/nl/'*/

export const urlBase = window.location.origin
export const urlHost = '/'
export const themeDir = '/wp-content/themes/nl/'
export const mp3Url = '/wp-content/themes/nl/mp3/'
